
import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatarParaMoedaBRL } from "../../../utils";



export default function PendenciaCompany({
  pendenciaCompany
}: {
  pendenciaCompany: any
}) {
  const { t } = useTranslation();
  
  if(pendenciaCompany.spc && pendenciaCompany.spc.spc){
    pendenciaCompany = pendenciaCompany.spc;
  }
  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
  }

  const avalista = (item:any) => {
    return item.avalista ? 'Sim' : 'Não';
  };

  const valor = (item:any) => {
    return formatarParaMoedaBRL(item.valorPendencia);
  };

  const valorSPC = (item:any) => {
    return formatarParaMoedaBRL(item.valor);
  };

  const dataConsulta = (item:any) => {
    return formatDate(new Date(item.dataConsulta));
  };

  const dataUltimoCheque = (item:any) => {
    return formatDate(new Date(item.dataUltimoCheque));
  };
  

  const dataInclusao = (item:any) => {
    return formatDate(new Date(item.dataInclusao));
  };

  const dataVencimento = (item:any) => {
    return formatDate(new Date(item.dataVencimento));
  };

  const dataRegistro = (item:any) => {
    return formatDate(new Date(item.dataOcorrencia));
  };

  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> <span style={{color:'#C70039', fontSize: '1.5rem'}} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('pendencias')}</span></span></div>;
  }

  const headerTemplateNegativacao = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> <span style={{color:'#C70039', fontSize: '1.5rem'}} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('negativacoes')}</span></span></div>;
  }

  const headerTemplateCCF = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> <span style={{color:'#C70039', fontSize: '1.5rem'}} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('ccf')}</span></span></div>;
  }
  
  return (
    <>
      
      {pendenciaCompany.ultimoEnderecoInformado && pendenciaCompany.ultimoEnderecoInformado.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && (
        <>
          <br></br>
          <Panel header={t('historicoEndereco')}>
            <DataTable size="small" value={pendenciaCompany.ultimoEnderecoInformado.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista} tableStyle={{ minWidth: '50rem' }}>
              <Column field="endereco.logradouro" header={t('logradouro')}></Column>
              <Column field="endereco.bairro" header={t('bairro')}></Column>
              <Column field="endereco.numero" header={t('numero')}></Column>
              <Column field="endereco.cep" header={t('cep')}></Column>
              <Column field="endereco.cidade.nome" header={t('cidade')}></Column>
              <Column field="endereco.cidade.estado.siglaUf" header={t('uf')}></Column>
            </DataTable>
          </Panel>
        </>
      )}
      {pendenciaCompany.consultaRealizada && pendenciaCompany.consultaRealizada.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && (
        <>
          <br></br>
          <Panel header={t('consultas')}>
            <DataTable size="small" value={pendenciaCompany.consultaRealizada.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista} tableStyle={{ minWidth: '50rem' }}>
              <Column body={dataConsulta} header={t('data')}></Column>
              <Column field="nomeAssociado" header={t('empresa')}></Column>
              <Column field="nomeEntidadeOrigem" header={t('origem')}></Column>
              <Column field="origemAssociado.nome" header={t('cidade')}></Column>
              <Column field="origemAssociado.estado.siglaUf" header={t('uf')}></Column>
            </DataTable>
          </Panel>
        </>
      )}
       {pendenciaCompany.pendenciaFinanceira && pendenciaCompany.pendenciaFinanceira.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && pendenciaCompany.pendenciaFinanceira.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista.length > 0 && (
        <>
          <br></br>
          <Panel headerTemplate={headerTemplate}>
            <DataTable size="small" value={pendenciaCompany.pendenciaFinanceira.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista} tableStyle={{ minWidth: '50rem' }}>
              <Column body={dataRegistro} header={t('dataRegistro')}></Column>
              <Column body={avalista} header={t('avalista')}></Column>
              <Column field="contrato" header={t('contrato')}></Column>
              <Column body={valor} header={t('valor')}></Column>
              <Column field="origem" header={t('empresa')}></Column>
              <Column field="tituloOcorrencia" header={t('natureza')}></Column>
              <Column field="cidade.nome" header={t('cidade')}></Column>
              <Column field="cidade.estado.siglaUf" header={t('uf')}></Column>
            </DataTable>
          </Panel>
        </>
      )}

      {pendenciaCompany.spc && pendenciaCompany.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && pendenciaCompany.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista.length > 0 && (
        <>
          <br></br>
          <Panel headerTemplate={headerTemplateNegativacao}>
            <DataTable size="small" value={pendenciaCompany.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista} tableStyle={{ minWidth: '50rem' }}>
              {pendenciaCompany.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista.some((item: any) => item.dataInclusao) && (
                <Column body={dataInclusao} header={t('dataRegistro')}></Column>
              )}
              <Column body={dataVencimento} header={t('dataVencimento')}></Column>
              <Column field="compradorFiadorAvalista" header={t('tipo')}></Column>
              <Column field="contrato" header={t('contrato')}></Column>
              <Column body={valorSPC} header={t('valor')}></Column>
              <Column field="nomeAssociado" header={t('empresa')}></Column>
              <Column field="cidadeAssociado.nome" header={t('cidade')}></Column>
              <Column field="cidadeAssociado.estado.siglaUf" header={t('uf')}></Column>
            </DataTable>
          </Panel>
        </>
      )}

      {pendenciaCompany.ccf && pendenciaCompany.ccf.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && pendenciaCompany.ccf.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista.length > 0 && (
        <>
          <br></br>
          <Panel headerTemplate={headerTemplateCCF}>
            <DataTable size="small" value={pendenciaCompany.ccf.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista} tableStyle={{ minWidth: '50rem' }}>
              <Column field="ultimoCheque.dadosBancarios.banco.codigo" header={t('codigoBanco')}></Column>
              <Column field="ultimoCheque.dadosBancarios.banco.nome" header={t('banco')}></Column>
              <Column field="ultimoCheque.dadosBancarios.numeroAgencia" header={t('agencia')}></Column>
              <Column field="motivo.codigo" header={t('motivo')}></Column>
              <Column field="quantidade" header={t('quantidade')}></Column>
              <Column body={dataUltimoCheque} header={t('dataUltimaOcorrencia')}></Column>
            </DataTable>
          </Panel>
        </>
      )}

      {pendenciaCompany.grafiaPj && pendenciaCompany.grafiaPj.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && pendenciaCompany.grafiaPj.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista.length > 0 && (
        <>
          <br></br>
          <Panel header="Grafias">
            <DataTable size="small" value={pendenciaCompany.grafiaPj.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista} tableStyle={{ minWidth: '50rem' }}>
              <Column field="razaoSocial" header={t('razaoSocial')}></Column>
              
            </DataTable>
          </Panel>
        </>
      )}


    </>
  )
}
